import React from 'react';
import { Typography, Box, Link } from '@mui/material';
import { LOGIN_LOGIN, LOGIN_SIGNUP } from '../../constants';
import ButtonBox from '../../components/ButtonBox';
import '../../style/Login.css';

interface WarningProps {
    setLoginPage: React.Dispatch<React.SetStateAction<string>>;
}

const Warning: React.FC<WarningProps> = ({ setLoginPage }) => {

    return (
        <>
            <Typography className='login_typography_title'>
                Warning
            </Typography>

            <Typography className='login_typography_content'>
                Sorry, your token has expired.
            </Typography>

            <Typography className='login_typography_content'>
                Please{' '}
                <ButtonBox
                    text="Sign up"
                    onClick={() => setLoginPage(LOGIN_SIGNUP)}
                />
                {' '}again.
            </Typography >
            <Box display="flex" justifyContent="center" mt={2}>
                <Link
                    href="#"
                    color="primary"
                    underline="none"
                    onClick={() => setLoginPage(LOGIN_LOGIN)}
                >
                    Back to log in
                </Link>
            </Box>
        </>
    );
};

export default Warning;
